import isArray from 'lodash/isArray';
import each from 'lodash/each';

const CITATION_LITERATURE_FORMATTER_SHOW_FIELDS = [
  'articleNo',
  'issueTitle',
  'issueYear',
  'issueVolume',
  'issueNo',
  'issuePages',
  'patentNumber',
  'patentYear',
  'patentStatus',
];

export default function citationLiteratureFormatter(literatureInfo, raw) {
  const results = [];

  if (isArray(literatureInfo) && literatureInfo.length > 0) {
    each(literatureInfo, (itemDetails) => {
      each(CITATION_LITERATURE_FORMATTER_SHOW_FIELDS, (field) => {
        let value = itemDetails[field];
        if (typeof value === 'string') value = value.replace(/,+$/, '');
        if (value) {
          if (field === 'issueYear' || field === 'patentYear' || field === 'issueTitle') {
            value = raw ? value : ['<span class="rx-element-publication">', value, '</span>'].join('');
          }
          results.push(value);
        }
      });
    });

    return results.join(', ');
  }
  return literatureInfo;
}
